/* eslint-disable */
import store from '@/store'
export default function () {
  return {
    calculateDistanceSqrt: function (a, b) {
      var x1 = a.offset().left,
        y1 = a.offset().top,
        x2 = b.offset().left,
        y2 = b.offset().top;
      return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
    }.bind(this),
    isInElement: function (point, element) {
      var x = element.offset().left,
        y = element.offset().top,
        objWidth = element.width(),
        objHeight = element.height();
      if (x < point.x && point.x < x + objWidth && y < point.y && point.y < y + objHeight) {
        return true;
      }
      return false;
    }.bind(this),
    getContextPath: function () {
      var contextPath = document.location.pathname;
      var index = contextPath.substr(1).indexOf("/");
      contextPath = contextPath.substr(0, index + 1);
      return contextPath;
    }.bind(this),
    generateUID: function () {
      var guid = "";
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16);
        guid += n;
        if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
          guid += "-";
      }
      return guid;
    }.bind(this),
    judgeVersion: function () {
      userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("firefox") >= 1) {
        return "firefox";
      }
    }.bind(this),
    addFavorite: function () {
      var ctrl = (navigator.userAgent.toLowerCase()).indexOf('mac') != -1 ? 'Command/Cmd' : 'Ctrl';
      if (document.all) {
        window.external.addFavorite(window.location, document.title);
      } else if (window.sidebar) {
        window.sidebar.addPanel(document.title, window.location);
      } else {
        this.$talert('添加失败，请用Ctrl+D进行添加')
      }
    }.bind(this)
  }
}
